module.exports = __webpack_public_path__ + "static/img/jk4.fd182e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jk4.png
// module id = l+P5
// module chunks = 1